export default __webpack_public_path__ + "static/media/layout-type-horizontal-style-2.8cf8fd03.svg";